<script lang="ts">
import {defineComponent} from '@vue/composition-api'

export default defineComponent({
  name: 'RegistrationStatusCard',
  props: {
    valid: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeholder: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
})
</script>

<template>
  <div class="registration-status-card" :class="placeholder ? 'placeholder' : ''">
    <section class="title-section" :class="valid ? 'valid' : ''">
      <div class="icon">
        <slot name="icon" />
      </div>
      <div class="title">
        <slot name="title" />
      </div>
      <div class="status">
        <v-icon v-if="!placeholder" :size="32" :color="valid ? '#00803E' : '#DC182D'">
          {{ valid ? 'fa-solid fa-circle-check' : 'fa-solid fa-circle-xmark' }}
        </v-icon>
        <v-skeleton-loader v-else type="avatar" class="check-placeholder" />
      </div>
    </section>
    <section class="description-section" :class="valid ? 'valid' : ''">
      <slot name="description" />
    </section>
  </div>
</template>

<style lang="scss">
.check-placeholder {
  .v-skeleton-loader__avatar {
    width: 32px !important;
    height: 32px !important;
  }
}
</style>

<style lang="scss" scoped>
.registration-status-card {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(2, 1fr);

  &.placeholder {
    .title-section {
      height: 90px;
      border: 1px solid #bbbbbb;
      background: #e0e0e0;
    }
    .description-section {
      height: 90px;
      border: 1px solid #bbbbbb;
      border-top: 0;
    }
  }

  .title-section {
    display: flex;
    flex-direction: row;
    align-items: center;
    background: #fff3f4;
    padding: 0 20px;
    border-radius: 4px 4px 0 0;
    border: 1px solid #dc182d;

    .title {
      font-family: ProximaNovaExCnSbold, sans-serif !important;
      font-size: 24px !important;
      color: #222222;
      letter-spacing: -0.01em !important;
      text-transform: uppercase;
      margin-left: 1rem;
    }

    .status {
      margin-left: auto;
    }

    &.valid {
      border-radius: 4px 4px 0 0;
      border: 1px solid #00803e;
      background: #dbefdc;
    }
  }

  .description-section {
    display: flex;
    align-items: center;
    text-align: left !important;
    padding: 8px 16px;
    border-radius: 0 0 4px 4px;
    border: 1px solid #dc182d;
    border-top: 0;
    color: #dc182d;

    &.valid {
      border-radius: 0 0 4px 4px;
      border: 1px solid #00803e;
      color: #00803e;
    }
  }
}
</style>
